<div class="accordion-container">
  <div class="accordion-section" *ngFor="let section of sections">
    <!-- Accordion Header -->
    <button
      type="button"
      class="accordion-header d-flex justify-content-between align-items-center"
      (click)="toggleSection(section)"
    >
      <h3 class="section-title mb-0">
        {{ section?.testcase || section?.filename }}
      </h3>
      <span class="toggle-button">
        <img
          *ngIf="section.expanded"
          src="assets/images/virtusa-icons/remove-outline.svg"
          alt="add"
        />
        <img
          *ngIf="!section.expanded"
          src="assets/images/virtusa-icons/add-outline.svg"
          alt="add"
        />
      </span>
    </button>

    <!-- Accordion Content (Expanded) -->
    <div class="accordion-content" *ngIf="section.expanded">
      <div class="data-div">
        <div class="d-flex flex-row issue-title-div">
          <img src="assets/images/virtusa-icons/info-dark.svg" alt="tip" />
          <span class="issue-title">Issue</span>
        </div>
        <span class="issue-text">
          {{ section?.error }}
        </span>
      </div>

      <div class="suggestion-div" *ngIf="hasSuggestions(section?.suggestions)">
        <div class="suggestion-title">
          <div class="icon-div">
            <img src="assets/images/virtusa-icons/tip-light.svg" alt="tip" />
          </div>

          <span class="text-title">Recommended Actions</span>
        </div>
        <!-- Show as string if suggestions is a string -->
        <div class="px-3">
          <span *ngIf="!isArray(section?.suggestions)">{{
            section?.suggestions
          }}</span>

          <!-- Show as unordered list if suggestions is an array -->
          <ul *ngIf="isArray(section?.suggestions)">
            <li *ngFor="let suggestion of section?.suggestions">
              {{ suggestion }}
            </li>
          </ul>
        </div>
      </div>


    </div>
  </div>
</div>
